import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { accountTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const createAccount: accountTypes.CreateAccount = (data) => {
  return axios.post('/accounts', data);
};

type UseCreateAccountOptions = {
  config?: MutationConfig<typeof createAccount>;
};

export function useCreateAccount({ config = {} }: UseCreateAccountOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      toasts.loadingToast.loading('create-account', 'Creating account...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['accounts']);
      toasts.loadingToast.success('create-account', 'Account created successfully');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('create-account', serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: createAccount,
  });
}
